import PropTypes from "prop-types"

export default function XIcon({ width, height }) {
  return (
    <span className="svg-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 32 32"
      >
        <path d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm7.533-11.463l-4.496-4.492 4.496-4.491-2.996-2.996-4.492 4.493-4.493-4.493-2.994 2.996 4.491 4.491-4.491 4.492 2.994 2.996 4.493-4.493 4.492 4.493 2.996-2.996z" />
      </svg>
    </span>
  )
}

XIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
}

XIcon.defaultProps = {
  width: "32",
  height: "32",
}
